var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlarmClock = function SvgIconAlarmClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#icon-alarm-clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 25.125a11.374 11.374 0 1 0 22.748 0 11.374 11.374 0 0 0-22.748 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.25v4.875h3.25M15.375 10.5l-4.469 3.25M31.625 10.5l4.469 3.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-alarm-clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h39v39H4z"
  })))));
};
export default SvgIconAlarmClock;